<template>
  <BasePageLayout>
    <div slot="page__title">
      {{
        $vuetify.lang.t(
          '$vuetify.MANAGE_FINANCE.TEACHER_TRANSACTION_LIST.TITLE'
        )
      }}
    </div>
    <div class="pa-8">
      <v-row class="mb-4">
        <v-col class="d-flex flex-column align-item-center" cols="6">
          <v-card outlined class="pa-4 full-width">
            <div class="subtitle-1 font-weight-bold text--secondary mb-4">
              {{
                $vuetify.lang.t(
                  '$vuetify.MANAGE_FINANCE.TEACHER_TRANSACTION_LIST.LABEL_COURSE_QUANTITY_SOLD_IN_SIX_MONTH'
                )
              }}
            </div>
            <div class="caption text-right">
              {{
                $vuetify.lang.t(
                  '$vuetify.MANAGE_FINANCE.TEACHER_TRANSACTION_LIST.LABEL_TOTAL_BILL'
                )
              }}
            </div>
            <div
              class="mb-4 text-right font-weight-bold"
              style="color: #ff1d30"
            >
              {{ totalBill }}
            </div>
            <GraphStatistic
              :dataForChart="graphData"
              type="quantity"
              class="bg-white pt-0 rounded"
              style="height: 176px"
            />
          </v-card>
        </v-col>
        <v-col class="d-flex flex-column align-item-center" cols="6">
          <v-card outlined class="pa-4 full-width">
            <div class="subtitle-1 font-weight-bold text--secondary mb-4">
              {{
                $vuetify.lang.t(
                  '$vuetify.MANAGE_FINANCE.TEACHER_TRANSACTION_LIST.LABEL_REVENUE_IN_SIX_MONTH'
                )
              }}
            </div>
            <div class="caption text-right">
              {{
                $vuetify.lang.t(
                  '$vuetify.MANAGE_FINANCE.TEACHER_TRANSACTION_LIST.LABEL_TOTAL_REVENUE'
                )
              }}
            </div>
            <div
              class="mb-4 text-right font-weight-bold"
              style="color: #2e4493"
            >
              {{ Number(totalRevenue.toFixed(0)).toLocaleString() }}
              {{
                $vuetify.lang.t(
                  '$vuetify.MANAGE_FINANCE.TEACHER_TRANSACTION_LIST.LABEL_CURRENCY_UNIT'
                )
              }}
            </div>
            <GraphStatistic
              :dataForChart="graphData"
              type="price"
              class="bg-white pt-0 rounded"
              style="height: 176px"
            />
          </v-card>
        </v-col>
      </v-row>
      <v-card outlined class="px-4 py-2 mb-10" color="grey lighten-4">
        <div class="caption text--disabled text-center">
          {{
            $vuetify.lang.t(
              '$vuetify.MANAGE_FINANCE.TEACHER_TRANSACTION_LIST.LABEL_STATISTICS_WITH_SUCCESSFUL_ORDERS'
            )
          }}
        </div>
      </v-card>
      <div class="d-flex justify-space-between align-center mb-4">
        <div class="text-h6 font-weight-medium">
          {{
            $vuetify.lang.t(
              '$vuetify.MANAGE_FINANCE.TEACHER_TRANSACTION_LIST.TITLE_STATISTIC'
            )
          }}
        </div>
        <MonthPicker
          @change="(value) => onChangeMonth(value)"
          :disabled="loading"
        />
      </div>
      <NumberStatistic
        :totalBillsInMonth="reportResult.count"
        :income="reportResult.totalPrice"
        class="mb-5"
      />
      <TableStatistic
        :loading="loading"
        :items="statistic"
        :count="countTotal"
        @onPageChange="onPageChange"
      />
    </div>
  </BasePageLayout>
</template>
<script>
import GraphStatistic from './components/GraphStatistic'
import TableStatistic from './components/TableStatistic'
import BasePageLayout from '@/templates/layout/BasePageLayout'
import MonthPicker from '@/modules/Transaction/components/MonthPicker'
import NumberStatistic from '@/modules/TeacherSale/components/NumberStatistic'
import {mapActions, mapGetters} from 'vuex'
import dayjs from 'dayjs'
export default {
  components: {
    BasePageLayout,
    MonthPicker,
    TableStatistic,
    NumberStatistic,
    GraphStatistic,
  },
  computed: {
    ...mapGetters({
      authUser: 'auth/getAuthUser',
      countTotal: 'billStatistic/getCount',
      reportResult: 'billStatistic/getReport',
      graphData: 'billStatistic/getGraph',
    }),
    totalRevenue() {
      if (this.graphData && this.graphData.length) {
        return this.graphData
          .map((item) => item.totalPrice)
          .reduce((acc, cur) => acc + cur, 0)
      } else return 0
    },
    totalBill() {
      if (this.graphData && this.graphData.length) {
        return this.graphData
          .map((item) => item.count)
          .reduce((acc, cur) => acc + cur, 0)
      } else return 0
    },
  },
  data() {
    return {
      statistic: [],
      author: null,
      totalBillsInMonth: 0,
      income: 0,
      billsSuccess: 0,
      loading: false,
      startOfMonth: null,
      endOfMonth: null,
    }
  },
  async mounted() {
    setTimeout(async () => {
      let periodTime = new Date()
      periodTime.setMonth(periodTime.getMonth() - 6)
      await this.getGraphData({
        author: this.author.id,
        createdAt_gt: new Date(periodTime),
        createdAt_lt: new Date(),
      })
    }, 2000)
  },
  methods: {
    ...mapActions({
      fetchBillStatistic: 'billStatistic/fetch',
      fetchAuthors: 'author/fetchAuthors',
      count: 'billStatistic/count',
      report: 'billStatistic/report',
      getGraphData: 'billStatistic/getGraphData',
    }),
    async onPageChange(pagination) {
      if (!this.startOfMonth) return
      this.loading = true
      let result = await this.fetchBillStatistic({
        authors_in: [this.author.id],
        createdAt_gt: this.startOfMonth,
        createdAt_lt: this.endOfMonth,
        _skip: pagination.skip,
        _limit: pagination.limit,
        _populate: 'student',
      })
      this.loading = false
      this.statistic = result
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    async onChangeMonth(value) {
      this.reset()
      const teachers = await this.fetchAuthors({profileId: this.authUser.id})
      this.author = teachers[0]
      const currentDate = new Date(value)
      const startOfMonth = dayjs(currentDate).startOf('month').toISOString()
      const endOfMonth = dayjs(currentDate).endOf('month').toISOString()
      this.startOfMonth = startOfMonth
      this.endOfMonth = endOfMonth
      await this.count({
        authors_in: [this.author.id],
        createdAt_gt: this.startOfMonth,
        createdAt_lt: this.endOfMonth,
      })
      await this.report({
        author: this.author.id,
        createdAt_gt: this.startOfMonth,
        createdAt_lt: this.endOfMonth,
      })
    },
  },
  watch: {
    startOfMonth: {
      handler() {
        this.onPageChange({skip: 0, limit: 10})
      },
      immediate: true,
    },
  },
}
</script>
